// Initial state
const state = {
  title: '',
  sidebarItemKey: null
}

// Mutations
const mutations = {
  setTitle (state, title) {
    // console.log('Set title: ' + title)
    state.title = title
  },
  setSidebarItemKey (state, key) {
    // console.log('Set side bar item key: ' + key)
    state.sidebarItemKey = key
  }
}

// Actions
const actions = {
  setTitle ({ commit, state }, ctx) {
    commit('setTitle', ctx.title)
  },
  setSidebarItem ({ commit, state }, ctx) {
    // console.log('Set side bar item: ' + Object.keys(ctx))
    commit('setSidebarItemKey', ctx.key)
    commit('setTitle', ctx.text)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/page.js